import React from 'react';

import { IOutgrowFields } from '@/types/contentful';

export default function OutgrowIframe({ code }: Partial<IOutgrowFields>) {
  return code ? (
    <div
      dangerouslySetInnerHTML={{ __html: code || '' }}
      data-testid="outgrow-iframe"
    />
  ) : null;
}
